import type {
	ChildrenQueryData,
	ExpandedItems,
} from '@atlassian/jira-business-list-handlers/src/controllers/children/types.tsx';
import type { IssueId } from '@atlassian/jira-shared-types/src/general.tsx';
import { createStore, createHook } from '@atlassian/react-sweet-state';
import type { TimelineViewIssuesReturn } from '../../services/get-timeline-view-issues/types.tsx';

type State = {
	childrenQueryData: ChildrenQueryData<TimelineViewIssuesReturn>;
	expandedItems: ExpandedItems;
};

const getInitialState = () => ({ childrenQueryData: {}, expandedItems: {} });

const initialState = getInitialState();

const setChildrenQueryData =
	(issueId: string, newData: TimelineViewIssuesReturn) =>
	({ setState, getState }: { setState: (arg1: State) => void; getState: () => State }) => {
		const state = getState();
		const prevChildrenQueryData = state.childrenQueryData;
		setState({
			...state,
			childrenQueryData: {
				...prevChildrenQueryData,
				[issueId]: newData,
			},
		});
	};

const setIssueExpanded =
	(issueId: IssueId, isExpanded: boolean) =>
	({ setState, getState }: { setState: (arg1: State) => void; getState: () => State }) => {
		const state = getState();
		const prevExpandedItems = state.expandedItems;
		setState({
			...state,
			expandedItems: {
				...prevExpandedItems,
				// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
				[issueId as string]: isExpanded,
			},
		});
	};

const clearExpandedItems =
	() =>
	({ setState, getState }: { setState: (arg1: State) => void; getState: () => State }) => {
		const state = getState();
		setState({
			...state,
			expandedItems: {},
		});
	};

const actions = { setChildrenQueryData, setIssueExpanded, clearExpandedItems };

type Actions = typeof actions;

const Store = createStore<State, Actions>({
	initialState,
	actions,
	name: 'TimelineHierarchyStore',
});

export const useHierarchyStore = createHook(Store);
